/**
 * Section-header content reveal DOM contract (see docs/04-motion.md).
 *
 * Server components opt headline / aside / body into the shared GSAP timeline
 * via the props below. Islands query *within a root* so Intro scrub and
 * chapter scrubs never steal each other's targets.
 */

/** Marks SectionHeader filled/outlined lines for the localized SplitText reveal. */
export const SECTION_HEADLINE_ATTR = 'data-section-headline';

export const SECTION_HEADLINE_SELECTOR = `[${SECTION_HEADLINE_ATTR}]`;

/** Spread onto headline line elements targeted by SplitText. */
export const SECTION_HEADLINE_PROPS = { [SECTION_HEADLINE_ATTR]: '' } as const;

/**
 * Extra paint room for SplitText's clipped line masks. Arabic glyphs extend
 * farther below the Latin line box, so RTL headlines need a deeper block-end
 * mask without changing layout (the matching negative margin cancels it).
 */
export const SECTION_HEADLINE_MASK_PADDING = {
  blockStart: '0.35em',
  blockEnd: '0.22em',
  rtlBlockEnd: '0.42em',
} as const;

/** Marks a header aside — fades and rises with the headline segment. */
export const SECTION_ASIDE_REVEAL_ATTR = 'data-section-aside-reveal';

export const SECTION_ASIDE_REVEAL_SELECTOR = `[${SECTION_ASIDE_REVEAL_ATTR}]`;

/** Spread onto the aside reveal root. */
export const SECTION_ASIDE_REVEAL_PROPS = { [SECTION_ASIDE_REVEAL_ATTR]: '' } as const;

/** Marks the nested stat bubble that scales while its aside fades in. */
export const SECTION_ASIDE_SCALE_ATTR = 'data-section-aside-scale';

export const SECTION_ASIDE_SCALE_SELECTOR = `[${SECTION_ASIDE_SCALE_ATTR}]`;

/** Spread onto the stat-only scale target inside a section-header aside. */
export const SECTION_ASIDE_SCALE_PROPS = { [SECTION_ASIDE_SCALE_ATTR]: '' } as const;

/**
 * Marks the body wrapper (pin + prose) for the scrubbed content fade.
 * Also the discernibility root for LocationPin / SectionProseReveal.
 */
export const SECTION_BODY_REVEAL_ATTR = 'data-section-body-reveal';

export const SECTION_BODY_REVEAL_SELECTOR = `[${SECTION_BODY_REVEAL_ATTR}]`;

/** Spread onto the body reveal root. */
export const SECTION_BODY_REVEAL_PROPS = { [SECTION_BODY_REVEAL_ATTR]: '' } as const;
